$(function () {
    //trip  menu:

    $(document).on("click", ".report-menu .dropdown-menu .dropdown-item[data-event]", function (e) {
        e.preventDefault();     
        var menuevent = $(this).data("event");
        var rid = $(this).parent().data("rid");      
        var rName = $(this).parent().data("rname");
        var eventObject = jQuery.Event(menuevent, { rid: rid, rName: rName, href:$(this).attr("href") });
        $(this).parent().trigger(eventObject);
    });
        
    $(document).on("traveler_delete", (event) => {
        event.preventDefault();      
       
        if (event.rid != undefined && event.rid != "") {
            do_traveler_delete(event.rid, event.rName)
        }
    });
   
    $(document).on("trip_select", (event) => {
        event.preventDefault();    
        showModal({ url: "/widgets/Trip/Trip-Select.aspx?m=2", saveText: "or Create New Trip", title: "Select a Trip", callback: function (modal) { tripSelectOpenCreateTrip(modal);} });  
      });
             
    $(document).on("trip_new", (event) => {
        event.preventDefault();    
         showModal({url: "/widgets/Trip/Trip-Detail.aspx?m=1", saveText: "Save Trip",title: "Create Trip", callback: function (modal) {tripSelectOnCreateTrip(modal) } });
    return false;
    
    });

    $(document).on("trip_clear", (event) => {
        event.preventDefault();    
        showSystemNotification("Clearing working trip...");  
        refreshPageForTrip ("","New Trip")                     
      });
              
    $(document).on("trip_edit", (event) => {
        event.preventDefault();      
        showModal({ url: "/widgets/Trip/Trip-Detail.aspx?m=2&rid=" + event.rid, saveText: "Save Trip", title: "Edit Trip",         
            callback: function (modal) {saveTripDetail(modal)}
        });
      });

    $(document).on("trip_print", (event) => {
        event.preventDefault();  
        printTrip(event.rid);
      });
            
    $(document).on("trip_travelers", function (event) {
        event.preventDefault();             
        showModal({ url: "/widgets/Trip/Trip-Travelers.aspx?rid=" + event.rid, showSave:false, title: "Trip Travelers" });
    });

    $(document).on("trip_send", function (event) {
        event.preventDefault();
        doSendTrip (event.rid,"Send Trip","Send Trip")
    })

    $(document).on("trip_send_history", function (event) {
        event.preventDefault();             
        showModal({ url: "/widgets/Trip/Trip-History.aspx?rid=" + event.rid, width:"1000px", showSave:false, title: "Trip Send History" });


    })

    $(document).on("trip_copy_url", function (event) {
        event.preventDefault();
        var targetURL =  window.location.origin +event.href;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(targetURL)
                .then(() => {
                    showSystemNotification("URL '" + targetURL +"' copied successfully!");
                })
                .catch(err => {
                     showSupportNotification("Unable to copy the URL '" + targetURL +"' to your clipboard (" + err + ").");                     
                });
        } else {
             showSupportNotification("Unable to copy the URL '" + targetURL +"' to your clipboard (no clipboard available).");                
        }
    });

    $(document).on("trip_duplicate", function (event) {
        event.preventDefault();
        if (event.rid != undefined && event.rid != "") {
            if (confirm("Are you sure you want to duplicate trip '" + event.rName + "'?")) {
                var req = new Object;
                req.ReportID = event.rid;             
                var DTO = { 'Req': req }
                DynaProxy.invoke("DuplicateTrip", DTO, function (data) {
                     showSystemNotification("Trip '" + event.rName + "' has been duplicated and we are taking you to it.");
                     window.location="/Trip?rid=" + data
                }, function (data) {            
                    showSupportNotification("Unable to duplicate trip '" + event.rName + "'.");
                })
            }
         }
    });

    $(document).on("trip_delete", function (event) {
        event.preventDefault();      
       
        if (event.rid != undefined && event.rid != "") {
            if (confirm("Are you sure you want to delete Trip '" + event.rName + "'? (this cannot be undone)")) {
                Page_Blur(true);
                DynaProxy.invoke("DeleteTrips", { rids: event.rid }, function (data) {
                    showSystemNotification("Trip '" + event.rName + "' has been deleted.")                       
                    if ($(".trip-plan-table").length > 0) {
                        Page_Blur(false);
                        refrehTripList(false);                         
                    } else {        // from trip detail
                        window.location = "/Home";
                    }
                }, function (data) {
                    Page_Blur(false);
                    showSupportNotification("Unable to delete Trip '" + event.rName + "'.");
                })                       
            }
        }
       
    })
              
})